import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/698bece3f782d500143c5ce1_1780477742350/containers_by_takeazip/src/app/contact/page.tsx");
